import { createSlice } from "@reduxjs/toolkit";

export const dealerAccountsSlice = createSlice({
  name: "filters",
  initialState: {
    dealerAccountsFilter: {},
  },
  reducers: {
    setDealerAccountsFilter: (state, action) => {
      return { ...state, dealerAccountsFilter: action.payload };
    },
    ResetDealerAccountsFilter: (state, action) => {
      return { dealerAccountsFilter: {} };
    },
  },
});

export const { setDealerAccountsFilter, ResetDealerAccountsFilter } = dealerAccountsSlice.actions;

export default dealerAccountsSlice.reducer;
